import adminHttp from './adminHttp';

/**
 * GET /admin/plans?type=
 *
 * The plan catalogue for one entity type. Declarants and operators have different
 * catalogues, and consultants have none — the caller must not ask for one, which is
 * why `type` is required rather than defaulted.
 */
export const fetchPlans = async (type) => {
  const { data } = await adminHttp.get('/admin/plans', { params: { type } });
  return data;
};
